import { useEffect, useState } from "react";
import { message, ModalProps, Tabs } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { apiPayment } from "../../services/apiPayment";
import { UserPlan } from "./UserPlan/index";
import { UserPlans } from "../../constants/plans";
import { PlanModalStyled } from "./UserPlan/styles";
import { useAuth } from "../../contexts/AuthContext";
import { FreeLimitText } from "../../constants/darf";
import { Content, Loading } from "../PlanModal/styles";
import CreditCardStep from "../Payment/CreditCardStep";
import { PaymentModal } from "../../components/PaymentModal";


interface IUserPlanModal extends ModalProps {
  modalPlans?: any[];
  paymentData?: any;
  closeModal?: any;

}
var getStatus: NodeJS.Timeout;

export const UserPlanModal: React.FC<IUserPlanModal> = ({
  title,
  modalPlans,
  onCancel,
  paymentData,
  closeModal,
  ...rest
}) => {
  const [loading] = useState(false);
  const [planCurrent, setPlan] = useState<any>();
  const [closable, setClosable] = useState(true);
  const { getUserInfo, user, showUserPlanModal, updateUserInfo } = useAuth();
  const [paymentModal, setPaymentModal] = useState(false);

  const handleDeselectPlan = () => {
    setPlan(undefined);
  };

  const handleSuccess = (data: any) => {
    checkWasPaid(data.paymentId, 4);
  };

  const checkWasPaid = (id: string, delay: number = 2) => {
    let attempts = 0;

    getStatus = setInterval(async () => {
      apiPayment
        .get(`user-plan/plan-info`)
        .then((res) => {
          if (res.data?.dueDate) {
            clearInterval(getStatus);
            message.success("Pagamento Confirmado com sucesso!");
            setPlan(undefined);
            registerFreeAction();
            showUserPlanModal(false);
            getUserInfo();
          }
        })
        .finally(() => {
          attempts += 1;

          if (attempts > 100) {
            clearInterval(getStatus);
          }
        });
    }, delay * 1000);
  };

  const registerFreeAction = () => {
    if (user.user.userPlanInfoVelotax.active) return;

    apiPayment
      .put("/user-plan/action")
      .then(() => {
        updateUserInfo();
      })
      .catch(() => {
        message.error("Ocorreu um erro tente novamente");
      });
  };

  useEffect(() => {
    if (planCurrent) {
      showUserPlanModal(true, "Pagamento");
    }
  }, [planCurrent, showUserPlanModal]);

  return (
    <PlanModalStyled
      footer={null}
      closable={closable}
      destroyOnClose
      bodyStyle={
        planCurrent && planCurrent.title !== "VELOTAX_MAIN_FREE"
          ? { backgroundColor: "var(--white)" }
          : {}
      }
      title={
        title
          ? title
          : !user?.user?.userPlanInfoVelotax?.active &&
            !user?.user?.userPlanInfoVelotax?.actionFree
            ? FreeLimitText
            : "Planos"
      }
      onCancel={(e) => {
        if (onCancel) onCancel(e);
        setPlan(undefined);
      }}
      {...rest}
    >
      <Content>
        {loading && (
          <Loading>
            <LoadingOutlined color="var(--ant-primary-color)" size={24} />
          </Loading>
        )}


        {!planCurrent && (
          <Tabs>
            {UserPlans.map((plan: any) => (
              <Tabs.TabPane tab={plan?.interval} key={plan?.interval}>
                <UserPlan
                  plan={plan}
                  handleSelect={() => {
                    if (plan?.type === 'MYNT_PRO') setPaymentModal(true);

                    plan && setPlan(plan);
                  }}
                  planBuyed={user?.user?.userPlanInfoVelotax?.type}
                />
              </Tabs.TabPane>
            ))}
          </Tabs>
        )}

        {planCurrent && planCurrent?.type === "MYNT_PRO_MONTH" && (
          <CreditCardStep
            plan={planCurrent}
            initialized={true}
            handleBack={handleDeselectPlan}
            typePurchase={planCurrent.type}
            darfData={paymentData}
            handleClosableModal={setClosable}
            status=""
            backToRoot={() => setPlan(undefined)}
            handleSuccess={handleSuccess}
            setInitialized={() => { }}
            getCardCurrentStep={(value: number) => { }}
          />
        )}

        {planCurrent && planCurrent?.type === "MYNT_PRO" &&
          <PaymentModal
            show={paymentModal}
            onCancel={(e: any) => {
              setPaymentModal(false);
              closeModal(false);
              handleDeselectPlan();
              setPlan(undefined);
            }}
            paymentData={{ ...paymentData, type: planCurrent?.type, isPlan: true }}
            callDarf={(value: boolean) => { }}
            planCurrent={planCurrent}
            hideDarfDownload
            onSucessCreditCard={handleSuccess}
            onSucessPix={checkWasPaid}
          />
        }

      </Content>
    </PlanModalStyled>
  );
};
